import DragIndicator from "@material-symbols/svg-500/rounded/drag_indicator.svg?react";
import { memo } from "react";

import { IconCreator } from "./_utils/icon-creator";

import type { SVGIconProps } from "./_utils/icon-creator";

const DragIndicatorIcon = (props: SVGIconProps) => {
	const Icon = () => IconCreator({ ...props, svgIcon: DragIndicator });
	return <Icon />;
};

export default memo(DragIndicatorIcon);
